<template>
  <div id="header">
    <div class="header-content">
      <div class="app-close" v-show="false"></div>
      <div class="app-symbol">
        <img style="width:0.4rem;height:0.4rem;" :src="logo" alt="" />
        <!-- <img
          style="width:0.4rem;height:0.4rem;"
          src="@/assets/demo/deepLogo.png"
          alt=""
        > -->
      </div>
      {{ robotConfig.name }}
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'AppHeader',
    data () {
      return {
        logo: require('@/assets/demo/logo_blue.png')
      }
    },
    computed: {
      ...mapState(['appConfig', 'robotConfig'])
    },
    watch: {
      robotConfig: {
        deep: true,
        handler (config) {
          document.title = config.name
        }
      }
    },
    methods: {
      // 换主题
      theme (type) {
        // this.$store.commit('upDate', { themeType: type })
        window.document.documentElement.setAttribute('data-theme', type)
      }
    },
    mounted () {
      // this.robotName = this.appConfig.orgCode === 'sichuan' ? '四川考试网智能客服' : '人社部人事考试中心智能客服'
      // console.log(this.$cookie)
      // if (this.$cookie.get('theme') !== undefined) {
      // console.log(this.$cookie.get('theme'))
      // }
      this.theme('light')
    }
  }
</script>

<style lang="scss" scoped>
  $logo-size: 0.4rem;

  #header {
    position: relative;
    z-index: 10;

    &:before {
      display: block;
      height: 4px;
      margin-top: 4px;
      @include background_color("theme-color-1");
      // background-color: $theme-color-1;
      content: "";
      border-radius: 4px;
      overflow: hidden;
    }

    .header-content {
      margin-top: 5px;
      margin-bottom: 6px;
      padding-left: $logo-size + 0.09;
      padding-right: 0.28rem;
      font-size: 0.22rem;
      @include font_color("theme-color-2");
      font-weight: bold;
      line-height: $logo-size;
      @include clear();

      .app-symbol {
        float: left;
        width: $logo-size;
        height: $logo-size;
        margin-left: -($logo-size + 0.09);
        border-radius: $logo-size;
        // overflow: hidden;
        text-align: center;
        position: relative;
        // img {
        //   // margin-top: .06rem;
        // }
      }

      .app-close {
        position: absolute;
        top: 0.08rem;
        right: 0;
        width: 0.468rem;
        height: 0.46rem;
        background-image: url("../assets/icons/i-close-d.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 0.16rem;
        cursor: pointer;
        transition: all ease 0.2s;

        &:hover {
          @include background_color("theme-color-3");
          // background-color: $theme-color-3;
          background-image: url("../assets/icons/i-close-w.png");
        }
      }
    }

    @media screen and (max-height: 640px) {
      .header-content {
        margin-top: 5px;
        margin-bottom: 6px;
        padding-left: $logo-size + 0.09;
        padding-right: 0.28rem;
        font-size: 0.18rem;
        @include font_color("theme-color-2");
        font-weight: bold;
        line-height: $logo-size;
      }
    }

    @media only screen and (device-width: 375px) {
      .header-content {
        margin-top: 5px;
        margin-bottom: 6px;
        padding-left: $logo-size + 0.09;
        padding-right: 0.28rem;
        font-size: 0.18rem;
        @include font_color("theme-color-2");
        font-weight: bold;
        line-height: $logo-size;
      }
    }
  }

  .common-util {
    font-size: 18px;
    @include font_color("font_color1");
    @include background_color("background_color1");
    @include border_color("border_color1");
  }
</style>